import { Component, OnInit, ViewEncapsulation, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, User } from '../../shared';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Options } from '@angular-slider/ngx-slider';
import { TranslateService } from '@ngx-translate/core';


@Component({
  templateUrl: 'painlevel.component.html',
  styleUrls: ['./style.component.css']
})

export class PainlevelComponent implements OnInit {
  public data: Object;
  value: any;
  painlevel: any = 0;
  CurrentUser: User;
  modalRef: BsModalRef;
  enableshow: boolean = false;
  difflevel: any = 0;
  showHide = false;

  level: any = "Pain Level";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private userservice: UserService,
    private translate: TranslateService
  ) { 
    this.translate.setDefaultLang(userservice.defaultLang);
  }

  ngOnInit() {
    this.userservice.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )
    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
  }

  myOnFinish(event: any) {
    //////console.log(event.from);
    this.painlevel = event.value;
  }

  myOnFinish1(event: any) {
    //////console.log(event.from);
    this.difflevel = event.from;
  }

  nextlevel(level) {
    if (level == "Pain Level") {
      this.level = "Difficulty Level";
    }
    else {
      this.level = "Pain Level";
    }
  }

  backlevel(level) {
    this.level = "Pain Level";
  }

  submit(confirmpopup: TemplateRef<any>) {
    this.enableshow = true;
    //////console.log(this.difflevel);
    // this.userservice.updatescore(this.painlevel,this.difflevel)
    // .subscribe(
    //   data=>{
    //     if(data.item.status == "success")
    //     this.userservice.logAudit("updatescore",0).subscribe(data =>{})
    //     this.enableshow=false;
    //       this.modalRef = this.modalService.show(confirmpopup,{class: 'modal-sm', backdrop: false , ignoreBackdropClick: true});
    // })
  }

  sliderOption() {
    let options: Options = {
      floor: 0,
      ceil: 10,
      step: 0.1,
      minRange: 0,
      maxRange: 10,
      showTicks: true,
      getLegend: (value: number): any => {
        return value;
      }
    };
    return options
  }

}
